<!--
하우스 센터이동 컴포넌트
------------------------------------
-->
<template>
    <!-- 폼 화면 -->
    <div class="uk-flex-top" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog uk-margin-auto-vertical uk-width-xxlarge">
            <div class="uk-modal-header">
                <h4>
                    <i class="material-icons">done</i>
                    배달완료 설정
                </h4>
            </div>

            <div class="uk-modal-body uk-padding-small">

                <!-- 단계 -->
                <div class="">
                    <i class="material-icons">label</i>
                    <b>현재단계</b>
                    :
                    <span class="text-black">{{ house.state_text }}</span>
                </div>

                <!-- 하우스정보 -->
                <div class="mt-1rem">
                    <i class="material-icons">mail</i>
                    <b>수취인정보</b>
                </div>
                <table class="info-table small uk-width-1-1">
                    <colgroup>
                        <col style="width: 9rem">
                        <col>
                        <col style="width: 9rem">
                        <col>
                    </colgroup>

                    <tr>
                        <th>
                            수취인
                        </th>
                        <td>
                            {{ house.name }}
                        </td>
                        <th>
                            배송코드
                        </th>
                        <td>
                            {{ house.code }}
                        </td>
                    </tr>
                    <tr>
                        <th>

                            우편번호
                        </th>
                        <td>
                            {{ house.zipcode }}
                        </td>
                        <th>

                            합배송코드
                        </th>
                        <td>
                            {{ house.sp_code }}
                        </td>
                    </tr>

                    <tr>
                        <th>

                            주소
                        </th>
                        <td colspan="3">
                            {{ house.addr1 }}
                            {{ house.addr2 }}
                        </td>
                    </tr>

                    <tr>
                        <th>
                            핸드폰 / 전화번호
                        </th>
                        <td>
                            {{ house.cell }}
                            <span v-if="house.tel">/ {{ house.tel }}</span>
                        </td>

                        <th>
                            운송장
                        </th>
                        <td>
                            {{ house.blno }}
                            <div class="uk-text-meta" v-if="house.sub_blnos">
                                {{ house.sub_blnos }}
                            </div>
                        </td>
                    </tr>

                    <tr>
                        <th>
                            배송메모
                        </th>
                        <td>
                            {{ house.sp_memo }}
                        </td>

                        <th>

                            통관정보
                        </th>
                        <td>
                            {{ house.customs_clearance_no }}
                            {{ house.customs_reg_no }}
                            {{ house.customs_biz_no }}
                            {{ house.customs_foreign_no }}
                            {{ house.customs_passport_no }}
                            {{ house.customs_nation }}

                        </td>
                    </tr>


                </table>

                <!-- 상품정보 -->
                <div class="mt-1rem">
                    <i class="material-icons">list</i>
                    <b>상품정보({{ houseProds.length }})</b>
                </div>
                <div class="prod-list">
                    <table class="info-table small uk-width-1-1">
                        <colgroup>
                            <col style="width: 7rem">
                            <col style="width: 15rem">
                            <col style="width: 4rem">
                            <col>

                        </colgroup>

                        <thead>
                        <tr>
                            <th scope="col" class="uk-text-center">
                                상품번호
                            </th>
                            <th scope="col" class="uk-text-left">
                                배송단계/등록일/해외오더/트래킹
                            </th>

                            <th scope="col" class="uk-text-center">
                                수량
                            </th>
                            <th scope="col" class="uk-text-left">
                                상품정보
                            </th>
                        </tr>
                        </thead>

                        <tbody>
                        <tr v-for="(prod) in houseProds"
                            :key="prod.id"
                        >
                            <td scope="col" class="uk-text-center">
                                {{ prod.id }}
                                <a class="detail-link" :href="'/prods/' + prod.id" target="_blank" title="상세페이지 새창으로 열기">
                                    <i class="material-icons">open_in_new</i>
                                </a>
                            </td>
                            <td scope="col" class="uk-text-left">
                                <div class="uk-flex">
                                    <div class="uk-margin-small-right" title="배송단계"><i class="material-icons md-18">label</i>{{ prod.state_text}}</div>
                                    <div class="uk-margin-small-right" title="등록일"><i class="material-icons md-18">calendar_month</i>{{ dateYmd(prod.created_at) }}</div>
                                </div>
                                <div class="" title="해외오더"><i class="material-icons md-18">receipt</i>{{ prod.buy_order_code}}</div>
                                <div class="" title="트래킹"><i class="material-icons md-18">local_shipping</i>{{ prod.tracking_no}}</div>
                            </td>

                            <td scope="col" class="uk-text-center">
                                {{ prod.amount}}
                            </td>
                            <td scope="col" class="uk-text-left">
                                <div class="uk-flex uk-flex-left uk-flex-middle">
                                    <img class="prod-img" :src="prod.img_url"/>

                                    <div class="uk-width-expand uk-flex uk-flex-wrap">
                                        <div class="uk-margin-small-right" title="쇼핑몰" v-if="prod.vender_mall"><i class="material-icons md-18">info</i>{{ prod.vender_mall}}</div>
                                        <div class="uk-margin-small-right" title="브랜드" v-if="prod.brand"><i class="material-icons md-18">info</i>{{ prod.brand}}</div>
                                        <div class="uk-width-1-1" title="상품명" v-if="prod.name"><i class="material-icons md-18">title</i>{{ prod.name}}</div>
                                        <div class="uk-margin-small-right" title="색상" v-if="prod.color"><i class="material-icons md-18">info</i>{{ prod.color}}</div>
                                        <div class="uk-margin-small-right" title="사이즈" v-if="prod.size"><i class="material-icons md-18">info</i>{{ prod.size}}</div>
                                    </div>
                                </div>




                            </td>
                        </tr>
                        </tbody>

                    </table>
                </div>


            </div>



            <div class="uk-modal-footer uk-text-right">
                <!-- 주의사항 -->
                <div class="text-black mb-1rem">
                    정말 배달완료로 변경하겠습니까?
                </div>

                <!--- 버튼 -->
                <button
                    type="button"
                    class="uk-button uk-button-default uk-modal-close"
                >
                    <span uk-icon="icon: close"></span> 취소
                </button>
                <button
                    type="button"
                    class="uk-button uk-button-primary"
                    @click="submit()"
                >
                    <span uk-icon="icon: check"></span>
                    배달완료
                </button>
            </div>

        </div>
    </div>

</template>

<script>
    import moment from "moment";
    import regionAble from "../common/region-able.vue";
    export default {
        mixins: [
            regionAble,
        ],
        props: {
            // csrf-token
            csrfToken: String,
        },
        data: function () {
            return {


                // (object) 하우스정보
                house: {},

                // (array) 하우스 상품배열
                houseProds: [],


            };
        },
        mounted: function () {
            //console.log('mounted in component');
        },
        computed: {
        },
        methods: {
            /**
             * 날짜 변환
             * - 입력 : '2024-04-11 12:33:17'
             * - 출력 : '2024-04-11'
             * @param date_string
             * @return string
             */
            dateYmd(date_string) {
                if (! date_string) {
                    return null;
                }
                return moment(date_string).format('YYYY-MM-DD');
            },

            /**
             * 입력폼 display
             */
            displayForm() {

                UIkit.modal(this.$el).show();
            },

            /**
             * 폼
             * @param house_id 하우스ID
             */
            form(house_id) {

                // 초기화
                this.inputs = {
                    reason: null,
                    to_region_id: null,
                };

                // promise 생성
                let load = new Promise((resolve, reject) => {
                    //reject('failed !');

                    // ajax 옵션
                    let opts = {
                        type: 'get',
                        url: '/houses/' + house_id,
                        contentType: 'application/json',
                        data: {},
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });


                // promise 처리
                load.then((response) => {
                    this.house = response.house;
                    this.houseProds = response.house_prods;


                    //console.log(response);
                    // 폼띄우기
                    this.displayForm();
                });
            },


            /**
             * submit
             */
            submit() {
                // 전송
                let submited = new Promise((resolve, reject) => {

                    // ajax 옵션
                    let opts = {
                        type: 'patch',
                        url: '/houses/' + this.house.id + '/to-receive',
                        data: {
                            '_token': this.csrfToken,
                        },
                        success: (response, textStatus, jqXHR) => {
                            // promise 성공
                            resolve(response);
                        },
                    };

                    // ajax 실행
                    $.app.ajax.module.background(opts);
                });
                submited.then((response) => {
                    UIkit.modal.alert(response.msg).then(() => {
                        $.app.refresh();
                    });
                });



            },
        },
    }
</script>

<style lang="scss" scoped>


    // 테이블
    .info-table {
        th {
            background-color: #fafafa;
        }
        th, td {
            font-size: 0.875rem !important;
        }

        .material-icons {
            color: #666;
            margin-right: 0.25rem;
        }

        img.prod-img {
            width: 3rem;
            max-height: 3rem;
            margin-right: 0.5rem;
        }

        // 상품상세 링크
        a.detail-link {
            .material-icons {
                color: #1e87f0;
                margin: 0;
            }
        }
    }

    // 상품영역
    .prod-list {
        overflow: auto;
        max-height: 12rem;
    }

    // 컨펌화면
    .confirm-overlay {
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: rgba(0, 0, 0, 0.7);
        z-index: 9999;
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;

        .confirm-dialog {
            width: 90%;
            padding: 1rem;
            background-color: #fff;

        }
    }

</style>